/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Right_Right_Justify_Right_PosInputs */



/**
* | output |
* | --- |
* | "Right Justify / Right Position" |
*
* @param {Align_Right_Right_Justify_Right_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_right_right_justify_right_pos = /** @type {((inputs?: Align_Right_Right_Justify_Right_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Right_Right_Justify_Right_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Droite / Position Droite")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtsbündig / Rechtsposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giustifica a destra / Posizione corretta")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Правильное обоснование / Правильное положение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificación a la derecha / Posición correcta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右对齐 / 右对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右揃え / 右位置")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाएँ औचित्य / दाएँ स्थिति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à direita / Posicionamento correto")
	return /** @type {LocalizedString} */ ("Right Justify / Right Position")
});